import { Chip, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { onDateChipClick } from "../constants";
// import { dateRangeOptions, onDateChipClick } from "../constants";
import DateRangeComponent from "./DateRangeComponent";
// import { useCommonContext } from "../providers/CommonProvider";

const FilterModalDateSection = ({
  filterOptions,
  setFilterOptions,
  title,
  currentOptions,
  // options,
  // setOptions,
}) => {
  // const { setDateOptionReset, dateOptionReset } = useCommonContext();
  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);

  const [options, setOptions] = useState(currentOptions);
  // const [options, setOptions] = useState([
  //   { label: "All", selected: true },
  //   { label: "Today", selected: false },
  //   { label: "Past Week", selected: false },
  //   { label: "Last 30 Days", selected: false },
  //   { label: "Last 12 Months", selected: false },
  //   { label: "Enter a Range", selected: false },
  // ]);

  const handleOpenCalneder = () => {
    setOpen(true);
  };

  const handleCloseCalneder = () => {
    setOpen(false);
  };

  // console.log("reset:", dateOptionReset)

  // useEffect(() => {
  //   if (dateOptionReset === true) {
  //     setOptions(dateRangeOptions);
  //     // if (filterOptions?.length == 0) {
  //     // }
  //   }
  // }, [dateOptionReset, setDateOptionReset]);

  const handleDateChange = (dateObj) => {
    if (dateObj[0] && dateObj[1]) {
      let creationDate = `${title}: ${moment(dateObj[0]).format(
        "MM/DD/YYYY"
      )} - ${moment(dateObj[1]).format("MM-DD-YYYY")}`;

      // Update filterOptions with the new date range, replacing any existing date range filter
      const newFilterOptions = [];
      newFilterOptions.push(creationDate);
      setFilterOptions(newFilterOptions);
      // setDateOptionReset(false);
    }
  };

  // useEffect to update the selectedDateRange based on filterOptions
  useEffect(() => {
    const dateFilter = filterOptions.find((option) =>
      option.startsWith(`${title}:`)
    );
    if (dateFilter) {
      const dates = dateFilter.replace(`${title}: `, "").split(" - ");
      setDateRange([new Date(dates[0]), new Date(dates[1])]);

      // setDateOptionReset(false);
      const updatedOptions = options.map((option) => {
        // Check if the option's label is in filterOptions
        if (option.label == "Enter a Range") {
          return {
            ...option,
            selected: true,
          };
        }
      });
      // Update the options state
      setOptions(updatedOptions);
      setOpen(true);
    }

    const updatedOptions = options.map((option) => {
      // Check if the option's label is in filterOptions
      return {
        ...option,
        selected: filterOptions.includes(option.label),
      };
    });
    // Update the options state
    setOptions(updatedOptions);

    if (filterOptions.length == 0) {
      // setOptions([
      //   { label: "All", selected: true },
      //   { label: "Today", selected: false },
      //   { label: "Past Week", selected: false },
      //   { label: "Last 30 Days", selected: false },
      //   { label: "Last 12 Months", selected: false },
      //   { label: "Enter a Range", selected: false },
      // ]);
      let temp = [...options];
      temp.forEach((item, index) => {
        if (index === 0) temp[index].selected = true;
        else temp[index].selected = false;
      });
      setOptions(temp);
    }
  }, [filterOptions]);

  return (
    <Grid item container direction={"column"} style={{ paddingLeft: 10 }}>
      <div style={titleTextStyles}>{title}</div>
      <Grid container style={{ paddingTop: 16, paddingBottom: 16 }}>
        {options.map((item, index) => (
          <Chip
            label={item.label}
            color={item.selected ? "primary" : undefined}
            style={item.selected ? selectedChipStyles : chipStyles}
            key={index}
            onClick={() => {
              onDateChipClick(
                index,
                item,
                handleOpenCalneder,
                handleCloseCalneder,
                setFilterOptions,
                options,
                setOptions
              );
              // setDateOptionReset(false);
            }}
          />
        ))}
        {open ? (
          <DateRangeComponent
            onChange={handleDateChange}
            currentDateRange={dateRange}
          />
        ) : undefined}
      </Grid>
    </Grid>
  );
};

export default FilterModalDateSection;

const chipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  cursor: "pointer",
  marginBottom: 5,
  fontFamily: "Avenir Book, sans-serif",
};
const selectedChipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  backgroundColor: "#00A7CD",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "pointer",
  marginBottom: 5,
  fontFamily: "Avenir Book, sans-serif",
};

const titleTextStyles = {
  color: "#020303",
  fontSize: 16,
  fontWeight: 700,
  marginRight: 20,
  fontFamily: "Avenir Book, sans-serif",
};
